import React, { useContext, useEffect, useRef, useState } from "react";
import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";
import ApexCharts from "react-apexcharts";
import { NavLink } from "react-router-dom";
import { currentDateAndTime, monthData } from "../../Constants/constants";
import GaugeChart from "react-gauge-chart";

import Select from "react-select";
import axios from "axios";
import { ConfigContext } from "../../Context/ConfigContext";
import { NoRecords } from "../../Components/Shimmer";
import { SubmitButton } from "../../Components/InputElements";
const SalaryDashboard = () => {
  const { apiURL, apiHeaderJSON } = useContext(ConfigContext);
  const sourceDivRef = useRef(null); // Ref for the source div
  const [targetDivHeight, setTargetDivHeight] = useState("auto");
  const [monthYear, setMonthYear] = useState("");
  const inputRef = useRef(null);
  const [dailyData, setDailyData] = useState({
    employee_count: "",
    presentee_count: "",
    today_leave_count: 0,
    monthly_leave_count: "",
  });
  const [selectedMonthYear, setSelectedMonthYear] = useState(null);
  const [selectedOfferStatus, setSelectedOfferStatus] = useState("0");
  const [selectedMonthYear1, setSelectedMonthYear1] = useState(null);
  const [selectedToMonthYear2, setSelectedToMonthYear2] = useState();
  const [errors, setErrors] = useState({});
  const [monthlyAttendanceData, setMonthlyAttendanceData] = useState({
    present_rate: "0.00%",
    absence_rate: "0.00%",
  });

  const [departmentAttendanceData, setDepartmentAttendanceData] = useState([]);
  const [gross, setGross] = useState([]);
  // const [attendanceData, setAttendanceData] = useState({
  //   absence_rate: "0.00%",
  //   present_rate: "0.00%",
  // });
  // const [AbsenceData,  setAbsenceData] = useState({});

  // const [PresentData, setPresentData] = useState({ });
  // const absenceRate = parseFloat(.absence_rate) / 100; // Convert "16.99%" to 0.1699
  //  const presentRate = parseFloat(attendanceData.present_rate)

  const [offerLetterStatusCounts, setOfferLetterStatusCounts] = useState({});
  const [offerSentCount, setOfferSentCount] = useState({});
  const currentDateAndTime = () => {
    return new Date().toISOString()?.slice(0, 19).replace("T", " "); // Example: '2024-12-24 15:30:00'
  };

  const currentDate = new Date();
  const currentMonth = String(currentDate.getMonth() + 1).padStart(2, "0"); // "11"
  const currentYear = currentDate.getFullYear(); // "2024"
  const [genderData, setGenderData] = useState([]);
  const [chartOptionsLeave, setChartOptionsLeave] = useState([]);
  const [attendanceData, setAttendanceData] = useState({
    present_rate: "0",
    absence_rate: "0",
  });
  const [chartOptionsGross, setChartOptionsGross] = useState([]);

  const [leaveData, setLeaveData] = useState([]);

  const [offerLetterCount, setOfferLetterCount] = useState(0);
  const [appointmentLetterCount, setappointmentLetterCount] = useState(0);
  const [selectMonthAppointment, setselectMonthAppointment] = useState("");
  const [monthYearOptions, setMonthYearOptions] = useState([]);
  const [selectMonthJoin, setSelectMonthJoin] = useState([]);

  const [departmentData, setDepartmentData] = useState([]);
  const [chartOptions, setChartOptions] = useState({});
  const [chartOptionsfGender, setChartOptionsGender] = useState({});
  const [charAttendenceData, setCharAttendenceData] = useState({});
  const [joiningData, setJoiningData] = useState({});
  const [locationCount, setLocationCount] = useState({});
  const [chartLocationOptions, setChartLocationOptions] = useState({});
  const [chartEarnedOptions, setChartEarnedOptions] = useState();
  const [departmentEarnedData, setDepartmentEarnedData] = useState();
  const [locationEarnedData, setLocationEarnedData] = useState();
  const [chartEarnedLocOptions, setChartEarnedLocOptions] = useState();
  const [departmentNetData, setDepartmentNetData] = useState();
  const [departmentGrossAndDeductionData, setDepartmentGrossAndDeductionData] =
    useState();
    const[chartSalaryOptions,setChartSalaryOptions] = useState();
    const[monthlySalary,setMonthlySalary]=useState();
  const [departmentNetSalaryData, setDepartmentNetSalaryData] = useState();
  const [chartNetOptions, setChartNetOptions] = useState();
  const [locationNetData, setLocationNetData] = useState();
  const [chartNetLocOptions, setChartNetLocOptions] = useState();
  const [chartOverTimeOptions, setChartOverTimeOptions] = useState();
  const [departmentOverTimeData, setDepartmentOverTimeData] = useState();
  const [selectMonthOver, setSelectMonthOver] = useState();
  const [selectMonthLocOver, setSelectMonthLocOver] = useState();
  const [chartLocOverTimeOptions, setChartLocOverTimeOptions] = useState();

  const [selectedToMonthYear, setSelectedToMonthYear] = useState(null);
  const [designationWiseProjecctionSal, setDesignationWiseProjecctionSal] =
    useState([]);
  const [rows, setRows] = useState([]);
  const[loadingFilter,setLoadingFilter]= useState(false)
  const[loadingFilter2,setLoadingFilter2]= useState(false)

  const [selectedNextMonth, setSelectedNextMonth] = useState();
  const [chartProjectionOptions, setChartProjectionOptions] = useState();
  // Helper function to get current month and year in "MM-YYYY" format
  const getCurrentMonthYear = () => {
    const date = new Date();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${month}-${year}`;
  };
  const [visibleDepartments, setVisibleDepartments] = useState(6); // Start with 6 departments
  const [projectionData, setProjectionData] = useState([]);

    const [filter, setFilter] = useState({
      keyword: null,
      month: null,
      attendanceMonth: null,
      location: null,
      department: null,
    });

  
  
  const getMonthYearOptions = () => {
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}DashboardRouter/GetAllMonthYearFromDatabase`, {
        params: {
          current_date: currentDateAndTime(),
        },
        headers,
      })
      .then((response) => {
        const data = response.data;
        console.log("MonthYearOptions =>", data);

        if (data.success) {
          setMonthYearOptions(data.filterData);
          const fromMonth =
            Array.isArray(data.filterData) && data.filterData.length > 0
              ? data.filterData[0]?.value
              : null;
          const toMonth =
            Array.isArray(data.filterData) && data.filterData.length > 1
              ? data.filterData[1]?.value
              : fromMonth;
          setSelectedMonthYear(fromMonth);
          setSelectedToMonthYear(toMonth);
          setMonthlySalary();

          const selectedMonth =
            Array.isArray(data.filterData) && data.filterData.length > 0
              ? data.filterData[0]?.value
              : null;

          
          const getNextMonth = (monthYear) => {
            if (!monthYear) return null;

            const [month, year] = monthYear.split("-").map(Number); 
            const date = new Date(year, month - 1);

            
            date.setMonth(date.getMonth() + 1);

           
            const nextMonth = `${String(date.getMonth() + 1).padStart(
              2,
              "0"
            )}-${date.getFullYear()}`;

            return nextMonth;
          };

        
          const nextMonth = selectedMonth
            ? getNextMonth(selectedMonth)
            : fromMonth;

          setSelectedMonthYear1(selectedMonth);
          setSelectedToMonthYear2(nextMonth);

          console.log("Selected Month:", selectedMonth);
          console.log("Next Month:", nextMonth);

          setCurrentIndex({
            departmentWiseCountIndex: 0,
            departmentWiseEarnedGrossIndex: 0,
            departmentWiseNetGrossIndex: 0,
            departmentWiseOverTimeHoursIndex: 0,
            monthlyWiseSlaryIndex: 0,
          });

          if (fromMonth && toMonth) {
            // getDepartmentWiseEarnedSalaryData(fromMonth, toMonth);
            // getLocationWiseEarnedSalaryData(fromMonth, toMonth);
            // getDepartmentWiseNetSalaryData(fromMonth, toMonth);
            // getLocationWiseNetSalaryData(fromMonth, toMonth);
          }
        } else {
          console.error("Failed to fetch month-year options");
        }
      })
      .catch((error) => {
        console.error("Error fetching month-year options:", error);
      });
  };

  
 

  const getDepartmentWiseEarnedSalaryData = (fromMonth, toMonth) => {
    const headers = apiHeaderJSON;
    setLoading(true);
    console.log("Fetching data for:", fromMonth, "to", toMonth);
    axios
      .get(`${apiURL}DashboardRouter/GetDepartmentWiseEarnedSalary`, {
        params: { from_month_year: fromMonth, to_month_year: toMonth },
        headers,
      })
      .then((response) => {
        const data = response.data;
        console.log("GetDepartmentWiseEarnedSalary =>", data);

        if (response.data.success === true) {
          let departmentTitles =
            data?.data?.map((dept) => dept.department_name) || [];
          console.log("departmentTitles", departmentTitles);
          setDepartmentGrossAndDeductionData(departmentTitles.length);
          let earnedSalaries =
            data?.data?.map((dept) => Math.round(dept.total_Earned_salary)) ||
            [];
          console.log("earnedSalaries", earnedSalaries);

          let deductions =
            data?.data?.map((dept) => dept.total_Deductions) || [];
          console.log("deductions", deductions);

          const chunkSize = 5;
          const nestedLabels = [];
          const transformedSeriesData = [];

          for (let i = 0; i < departmentTitles.length; i += chunkSize) {
            nestedLabels.push(departmentTitles.slice(i, i + chunkSize));
            transformedSeriesData.push([
              {
                name: "Earned Gross",
                data: earnedSalaries.slice(i, i + chunkSize),
              },
              {
                name: "Deductions",
                data: deductions.slice(i, i + chunkSize),
              },
            ]);
          }

          console.log("nestedLabels =>", nestedLabels);
          console.log("transformedSeriesData =>", transformedSeriesData);

          setChartEarnedOptions({
            labels: nestedLabels || [],
            series: transformedSeriesData || [],
          });
        } else {
          console.error(
            "Failed to fetch department-wise salary data:",
            data.message || "Unknown error"
          );
        }
      })
      .catch((error) => {
        console.error("Error fetching department-wise salary data:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };


  const getMonthlyTotalSalaryData = (fromMonth, toMonth) => {
    const headers = apiHeaderJSON;
    setLoading(true);
    console.log("Fetching data for:", fromMonth, "to", toMonth);
    axios
      .get(`${apiURL}DashboardRouter/GetMonthlyEarnedGrossDeductionsNet`, {
        params: { from_month_year: fromMonth, to_month_year: toMonth },
        headers,
      })
      .then((response) => {
        const data = response.data;
        console.log("getMonthlyTotalSalaryData ==>", data);

        if (response.data.success === true) {
          let montyear = data?.data?.map((dept) => dept.month_year) || [];
          console.log("orignalMontyear", montyear);
          setMonthlySalary(montyear.length);
          let earnedSalaries =
            data?.data?.map((dept) => Math.round(dept.total_earned_salary)) ||
            [];
          console.log("earnedSalaries", earnedSalaries);

          let deductions =
            data?.data?.map((dept) => dept.total_deductions) || [];
          console.log("deductions", deductions);

          let net =
          data?.data?.map((dept) => dept.total_net_pay) || [];
        console.log("net", net);
        

          const chunkSize = 5;
          const nestedLabels = [];
          const transformedSeriesData = [];

          for (let i = 0; i < montyear.length; i += chunkSize) {
            nestedLabels.push(montyear.slice(i, i + chunkSize));
            transformedSeriesData.push([
              {
                name: "Earned Gross",
                data: earnedSalaries.slice(i, i + chunkSize),
              },
              {
                name: "Deductions",
                data: deductions.slice(i, i + chunkSize),
              },
              {
                name: "Net",
                data:net.slice(i,i + chunkSize),
              },
            ]);
          }

          console.log("nestedLabelsMonth =>", nestedLabels);
          console.log("transformedSeriesDataMonth =>", transformedSeriesData);

          setChartSalaryOptions({
            labels: nestedLabels || [],
            series: transformedSeriesData || [],
          });
        } else {
          console.error(
            "Failed to fetch monthYear-wise salary data:",
            data.message || "Unknown error"
          );
        }
      })
      .catch((error) => {
        console.error("Error fetching department-wise salary data:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  // const getDepartmentWiseEarnedSalaryData = (fromMonth, toMonth) => {
  //   const headers = apiHeaderJSON;
  //   setLoading(true);

  //   console.log("Fetching data for:", fromMonth, "to", toMonth);  // Log values for debugging

  //   axios
  //     .get(`${apiURL}DashboardRouter/GetDepartmentWiseEarnedSalary`, {
  //       params: { from_month_year: fromMonth, to_month_year: toMonth },
  //       headers,
  //     })
  //     .then((response) => {
  //       const data = response.data;
  //       console.log("GetDepartmentWiseEarnedSalary response =>", data);

  //       if (response.data.success === true) {
  //         // Process the data here as required
  //         let departmentTitles = data?.data?.map((dept) => dept.department_name) || [];
  //         setDepartmentGrossAndDeductionData(departmentTitles.length);
  //         let earnedSalaries = data?.data?.map((dept) => Math.round(dept.total_Earned_salary)) || [];
  //         let deductions = data?.data?.map((dept) => dept.total_Deductions) || [];

  //         // Further processing...
  //       } else {
  //         console.error("Failed to fetch department-wise salary data:", data.message || "Unknown error");
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching department-wise salary data:", error);
  //     })
  //     .finally(() => {
  //       setLoading(false);  // Ensure loading state is updated
  //     });
  // };

  const chunkData = (data, chunkSize) => {
    if (!Array.isArray(data)) {
      console.warn("Invalid input: data is not an array");
      return [];
    }

    const chunked = [];
    for (let i = 0; i < data.length; i += chunkSize) {
      chunked.push(data.slice(i, i + chunkSize));
    }
    return chunked;
  };

  const getLocationWiseEarnedSalaryData = (fromMonth, toMonth) => {
    const headers = apiHeaderJSON;
    setLoading1(true);
    axios
      .get(`${apiURL}DashboardRouter/GetLocationWiseEarnedSalary`, {
        params: { from_month_year: fromMonth, to_month_year: toMonth },
        headers,
      })
      .then((response) => {
        const data = response.data;
        console.log("GetLocationWiseEarnedSalary =>", data);

        if (response.data.success === true) {
          const locationData = data?.data || []; // Ensure it's an array
          if (locationData.length === 0) {
            console.warn("No data available for the selected month.");
          }

          setLocationEarnedData(locationData);

          const locationTitles = locationData.map((dept) => dept.location_name);
          const earnedSalaries = locationData.map(
            (dept) => dept.total_Earned_salary
          );

          setChartEarnedLocOptions({
            labels: locationTitles || [],
            series: earnedSalaries || [],
          });
        } else {
          console.error(
            "Failed to fetch location-wise salary data. Message:",
            data.message
          );
        }
      })
      .catch((error) => {
        console.error("Error fetching location-wise salary data:", error);
      })
      .finally(() => {
        setLoading1(false);
      });
  };

  const getDepartmentWiseNetSalaryData = (fromMonth, toMonth) => {
    const headers = apiHeaderJSON;
    setLoading1(true);

    axios
      .get(`${apiURL}DashboardRouter/GetDepartmentWiseNetSalary`, {
        params: { from_month_year: fromMonth, to_month_year: toMonth },
        headers,
      })
      .then((response) => {
        const data = response.data;
        console.log("GetDepartmentWiseNetSalary =>", data);

        if (response.data.success === true) {
          let departmentTitles =
            data?.data?.map((dept) => dept.department_name) || [];
          console.log("departmentTitles", departmentTitles);
          setDepartmentNetSalaryData(departmentTitles.length);
          let netSalaries =
            data?.data?.map((dept) => Math.round(dept.total_Net_salary)) || [];
          console.log("netSalaries", netSalaries);

          setDepartmentNetData(departmentTitles.length);

          const chunkSize = 5; // Number of elements in each chunk
          const nestedLabels = [];

          if (departmentTitles.length > 0) {
            for (let i = 0; i < departmentTitles.length; i += chunkSize) {
              nestedLabels.push(departmentTitles.slice(i, i + chunkSize));
            }
          } else {
            nestedLabels.push("No data");
          }

          departmentTitles = nestedLabels;

          const chunks = [];

          if (netSalaries.length > 0) {
            for (let i = 0; i < netSalaries.length; i += chunkSize) {
              chunks.push(netSalaries.slice(i, i + chunkSize));
            }
          } else {
            chunks.push(0);
          }

          const transformedSeriseData = chunks.map((chunk) => ({
            name: "Department Wise Net Salary",
            data: chunk,
          }));

          netSalaries = transformedSeriseData;
          console.log("netSalaries =>", netSalaries);
          console.log("transformedSeriseData =>", transformedSeriseData);

          setChartNetOptions({
            labels: departmentTitles || [],
            series: netSalaries || [],
          });
        } else {
          console.error(
            "Failed to fetch department-wise net salary data:",
            data.message || "Unknown error"
          );
        }
      })
      .catch((error) => {
        console.error("Error fetching department-wise net salary data:", error);
      })
      .finally(() => {
        setLoading1(false);
      });
  };

  const getLocationWiseNetSalaryData = (fromMonth, toMonth) => {
    const headers = apiHeaderJSON;

    axios
      .get(`${apiURL}DashboardRouter/GetLocationWiseNetSalary`, {
        params: { from_month_year: fromMonth, to_month_year: toMonth },
        headers,
      })
      .then((response) => {
        const locData = response.data;
        console.log("GetLocationWiseNetSalary:", locData);

        if (response.data.success === true) {
          setLocationNetData(locData?.data);

          const locationTitles = locData?.data?.map(
            (dept) => dept.location_name
          );
          console.log("locationTitles", locationTitles);

          const netSalaries = locData?.data?.map(
            (dept) => dept.total_Net_salary
          );
          console.log("netSalaries", netSalaries);

          setChartNetLocOptions({
            labels: locationTitles || [],
            series: netSalaries || [],
          });
        } else {
          console.error("No location data available.");
        }
      })
      .catch((error) => {
        console.error("Error fetching location-wise salary data:", error);
      });
  };

  
  const getProjectionDesignationWiseSalaryData = (selectedMonth, nextMonth) => {
    const headers = apiHeaderJSON;
    setLoading(true);
    axios
      .get(`${apiURL}DashboardRouter/GetDesignationWiseSalaryChange`, {
        params: {
          selected_month_year: selectedMonth,
          next_month_year: nextMonth,
        },
        headers,
      })
      .then((response) => {
        const data = response.data;
        console.log("GetSalaryProjectionByDesignation =>", data);

        if (response.data.success === true) {
          let designationData = data?.data || [];

          setDesignationWiseProjecctionSal(designationData.length);

          const rows = designationData.map((dept) => ({
            designation_name: dept.designation_name,
            selectedmonth_total_employees: dept.selectedmonth_total_employees,
            nextmonth_total_employees: dept.nextmonth_total_employees,
            previous_avg_salary: dept.previous_avg_salary,
            current_avg_salary: dept.current_avg_salary,
            percentage_change: dept.percentage_change,
            percentage_status: dept.percentage_status,
          }));

          console.log("Mapped Rows: ", rows);

          setRows(rows); 
        } else {
          console.error(
            "Failed to fetch department-wise salary data:",
            data.message || "Unknown error"
          );
        }
      })
      .catch((error) => {
        console.error("Error fetching department-wise salary data:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const [selectedFromMonth, setSelectedFromMonth] = useState(null);
  const [selectedToMonth, setSelectedToMonth] = useState(null);
  const [toMonthOptions, setToMonthOptions] = useState([])
  const handleSelectChange = (name, selectedOption) => {
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  
    const selectedValue = selectedOption ? selectedOption.value : null;
  
    if (name === "from_month") {
      setSelectedFromMonth(selectedValue);
  
      
      if (selectedValue) {
        const fromMonthDate = parseMonthYear(selectedValue);
        setToMonthOptions(
          monthYearOptions.filter(
            (option) => parseMonthYear(option.value) >= fromMonthDate
          )
        );
      } else {
        setToMonthOptions(monthYearOptions);
      }
    } else if (name === "to_month") {
      setSelectedToMonth(selectedValue);
  
      if (selectedValue && selectedFromMonth) {
        const fromMonthDate = parseMonthYear(selectedFromMonth);
        const toMonthDate = parseMonthYear(selectedValue);
  
        if (fromMonthDate > toMonthDate) {
          setErrors((prevErrors) => ({
            ...prevErrors,
            to_month:
              "To Month-Year must be greater than or equal to From Month-Year.",
          }));
        } else {
          console.log("Fetching data for:", selectedFromMonth, selectedValue);
          // fetchAllData(selectedFromMonth, selectedValue);
          //handleApplyFilter(selectedFromMonth, selectedValue);
        }
      }
    }
  };
  //   const parseMonthYear = (monthYear) => {
  //     const [month, year] = monthYear.split("-");
  //     return new Date(`${year}-${month}-01`);
  //   };

  //   const fetchAllData = (fromMonth, toMonth) => {
  //     console.log("Data fetch triggered for:", fromMonth, toMonth);
  //     getDepartmentWiseEarnedSalaryData(fromMonth, toMonth);
  //     getLocationWiseEarnedSalaryData(fromMonth, toMonth);
  //     getDepartmentWiseNetSalaryData(fromMonth, toMonth);
  //     getLocationWiseNetSalaryData(fromMonth, toMonth);

  //   };
  //  const fetchAllData1 =(selectedMonth,nextMonth) =>{
  //     getProjectionDesignationWiseSalaryData(selectedMonth,nextMonth);
  //   }
  //   useEffect(() => {
  //     getMonthYearOptions();
  //     // getCurrentMonthYear();
  //     // if (inputRef.current) {
  //     //   flatpickr(inputRef.current, {
  //     //     dateFormat: "d M, Y",
  //     //     defaultDate: "today",
  //     //     inline: true,
  //     //   });
  //     // }

  //     const sourceDiv = sourceDivRef.current;

  //     if (sourceDiv) {
  //       const resizeObserver = new ResizeObserver((entries) => {
  //         for (let entry of entries) {
  //           // Update the target div height whenever the source div resizes
  //           setTargetDivHeight(`${entry.contentRect.height}px`);
  //         }
  //       });

  //       resizeObserver.observe(sourceDiv);

  //       return () => {
  //         resizeObserver.disconnect();
  //       };
  //     }
  //   }, []);


  const getNextMonth = (monthYear) => {
    if (!monthYear) return null;

    
    const [month, year] = monthYear.split("-").map(Number);
    const date = new Date(year, month - 1); 

    
    date.setMonth(date.getMonth() + 1);

    
    const nextMonth = `${String(date.getMonth() + 1).padStart(
      2,
      "0"
    )}-${date.getFullYear()}`;
    return nextMonth;
  };
  const handleSelectedMonthChange = (selectedOption) => {
    const selectedValue = selectedOption ? selectedOption.value : null;
  
    if (selectedValue) {
      const currentMonthYear = getCurrentMonthYear(); // Helper to get the current month-year as a string
      
      // If the user selects the current month, reset and exclude the current month
      if (selectedValue === currentMonthYear) {
        setSelectedMonthYear(null);
        setSelectedNextMonth(null);
        setToMonthOptions(
          monthYearOptions.filter(
            (option) => option.value !== currentMonthYear
          )
        );
        return;
      }
  
      // Proceed with the normal workflow if it's not the current month
      setSelectedMonthYear(selectedValue);
      const nextMonth = getNextMonth(selectedValue);
  
      setSelectedNextMonth(nextMonth);
      setToMonthOptions(
        monthYearOptions.filter(
          (option) =>
            parseMonthYear(option.value) >= parseMonthYear(selectedValue)
        )
      );
  
      if (selectedValue && nextMonth) {
        getProjectionDesignationWiseSalaryData(selectedValue, nextMonth);
      }
    } else {
      // Reset to defaults when no month is selected
      setSelectedMonthYear(null);
      setSelectedNextMonth(null);
      setToMonthOptions(monthYearOptions);
    }
  };
  
  
  // const handleSelectedMonthChange = (selectedOption) => {
  //   const selectedValue = selectedOption ? selectedOption.value : null;
  //   if (selectedValue) {
  //     setSelectedMonthYear(selectedValue);

     
  //     const nextMonth = getNextMonth(selectedValue);

      
  //     setSelectedNextMonth(nextMonth);

      
  //     setToMonthOptions(
  //       monthYearOptions.filter(
  //         (option) =>
  //           parseMonthYear(option.value) >= parseMonthYear(selectedValue)
  //       )
  //     );
  //     if (selectedValue && nextMonth) {
  //       getProjectionDesignationWiseSalaryData(selectedValue, nextMonth);
  //     }
  //   } else {
    
  //     setSelectedNextMonth(null);
  //     setToMonthOptions(monthYearOptions);
  //   }
  // };

  const handleToMonthChange = (selectedOption) => {
    const selectedValue = selectedOption ? selectedOption.value : null;
    setSelectedToMonth(selectedValue);

    if (selectedValue && selectedMonthYear) {
      const fromMonthDate = parseMonthYear(selectedMonthYear);
      const toMonthDate = parseMonthYear(selectedValue);

      if (fromMonthDate > toMonthDate) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          to_month:
            "To Month-Year must be greater than or equal to From Month-Year.",
        }));
        return;
      }

      fetchAllData(selectedMonthYear, selectedValue);
      // fetchAllData1(selectedMonth, nextMonth);
    }
  };

  
  const parseMonthYear = (monthYear) => {
    const [month, year] = monthYear.split("-");
    return new Date(`${year}-${month}-01`);
  };

  // Function to fetch the data for both the selected month and the next month
  const fetchAllData = (fromMonth, toMonth) => {
    console.log("Data fetch triggered for:", fromMonth, toMonth);
    getDepartmentWiseEarnedSalaryData(fromMonth, toMonth);
    getLocationWiseEarnedSalaryData(fromMonth, toMonth);
    getDepartmentWiseNetSalaryData(fromMonth, toMonth);
    getLocationWiseNetSalaryData(fromMonth, toMonth);
    getMonthlyTotalSalaryData(fromMonth,toMonth);
  };

  const fetchAllData1 = (selectedMonth, nextMonth) => {
    console.log("fetchAllData1", selectedMonth, nextMonth);
    getProjectionDesignationWiseSalaryData(selectedMonth, nextMonth);
  };
  useEffect(() => {
    getMonthYearOptions();
    getProjectionDesignationWiseSalaryData();
    // getCurrentMonthYear();
    // if (inputRef.current) {
    //   flatpickr(inputRef.current, {
    //     dateFormat: "d M, Y",
    //     defaultDate: "today",
    //     inline: true,
    //   });
    // }

    const sourceDiv = sourceDivRef.current;

    if (sourceDiv) {
      const resizeObserver = new ResizeObserver((entries) => {
        for (let entry of entries) {
          // Update the target div height whenever the source div resizes
          setTargetDivHeight(`${entry.contentRect.height}px`);
        }
      });

      resizeObserver.observe(sourceDiv);

      return () => {
        resizeObserver.disconnect();
      };
    }
  }, []);
  const [showMore, setShowMore] = useState(false);
  const handleShowMore = () => {
    setShowMore(!showMore);
    setVisibleDepartments(showMore ? 6 : chartOptions?.labels?.length);
  };
  const renderLabels = (labels) => (labels?.length > 0 ? labels : ["No Data"]);
  const renderSeries = (series) => (series?.length > 0 ? series : [0]);

  const chartOptionsLine = {
    chart: {
      type: "line",
    },
    series: [
      {
        name: "Joins",
        data: [30, 40, 45, 50, 49, 60, 70, 91],
      },
    ],
    xaxis: {
      categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug"],
    },
    colors: ["#687cfe"],
  };

  const [currentIndex, setCurrentIndex] = useState({
    departmentWiseCountIndex: 0,
    departmentWiseEarnedGrossIndex: 0,
    departmentWiseNetGrossIndex: 0,
    departmentWiseOverTimeHoursIndex: 0,
    monthlyWiseSlaryIndex:0,
  });
  const [animationDirection, setAnimationDirection] = useState({
    departmentWiseCountAnimation: "",
    departmentWiseEarnedGrossAnimation: "",
    departmentWiseNetGrossAnimation: "",
    departmentWiseOverTimeHoursAnimation: "",
    monthlySalarAnimation: "",
  });
  const [currentIndex1, setCurrentIndex1] = useState(0);
  const [currentIndex2, setCurrentIndex2] = useState(0);
  const [currentIndex3, setCurrentIndex3] = useState(0);
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [animating, setAnimating] = useState(false);


  const handleApplyFilter = () => {
    setLoadingFilter(true);
    const validationErrors = {};
    if (!selectedFromMonth) {
      validationErrors.from_month = "From Month-Year is required.";
    }
    if (!selectedToMonth) {
      validationErrors.to_month = "To Month-Year is required.";
    }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    // setLoadingFilter(true);
    setTimeout(() => {
      console.log("Filter applied with:", {
        from_month: selectedFromMonth,
        to_month: selectedToMonth,
      });
      fetchAllData(selectedFromMonth,selectedToMonth);
      setLoadingFilter(false);
      setLoadingFilter2(false);
     
    }, 1000);
  };
  const isFilterDisabled = !selectedFromMonth || !selectedToMonth;
  const handleClearFilter = () => {
    setLoadingFilter2(true);
    setTimeout(() => {
      setSelectedFromMonth(null);
      setSelectedToMonth(null);
      setLoadingFilter2(false)
      fetchAllData(false)
      setErrors({});
      setLoadingFilter2(false);
      console.log("Filters cleared");
    }, 1000);
  };

  const handlePrev = (type) => {
    if (animating) return;

    if (type === "1") {
      setAnimationDirection({
        ...animationDirection,
        departmentWiseCountAnimation: "slide-right",
      });
    } else if (type === "2") {
      setAnimationDirection({
        ...animationDirection,
        departmentWiseEarnedGrossAnimation: "slide-right",
      });
    } else if (type === "3") {
      setAnimationDirection({
        ...animationDirection,
        departmentWiseNetGrossAnimation: "slide-right",
      });
    } else if (type === "4") {
      setAnimationDirection({
        ...animationDirection,
        departmentWiseOverTimeHoursAnimation: "slide-right",
      });
    }
    else if(type === "5"){
      setAnimationDirection({
        ...animationDirection,
        monthlySalarAnimation: "slide-right",
      })
    }
    setAnimating(true);

    setTimeout(() => {
      if (type === "1") {
        setCurrentIndex({
          ...currentIndex,
          departmentWiseCountIndex:
            currentIndex?.departmentWiseCountIndex === 0
              ? chartOptions.series.length - 1
              : currentIndex?.departmentWiseCountIndex - 1,
        });
      } else if (type === "2") {
        setCurrentIndex({
          ...currentIndex,
          departmentWiseEarnedGrossIndex:
            currentIndex?.departmentWiseEarnedGrossIndex === 0
              ? chartEarnedOptions.series.length - 1
              : currentIndex?.departmentWiseEarnedGrossIndex - 1,
        });
      } else if (type === "3") {
        setCurrentIndex({
          ...currentIndex,
          departmentWiseNetGrossIndex:
            currentIndex?.departmentWiseNetGrossIndex === 0
              ? chartNetOptions.series.length - 1
              : currentIndex?.departmentWiseNetGrossIndex - 1,
        });
      } else if (type === "4") {
        setCurrentIndex({
          ...currentIndex,
          departmentWiseOverTimeHoursIndex:
            currentIndex?.departmentWiseOverTimeHoursIndex === 0
              ? chartNetOptions.series.length - 1
              : currentIndex?.departmentWiseOverTimeHoursIndex - 1,
        });
      }
      else if(type === "5"){
        setCurrentIndex({
          ...currentIndex,
          monthlyWiseSlaryIndex:
          currentIndex?.monthlyWiseSlaryIndex === 0
          ?chartSalaryOptions.series.length-1
          :currentIndex?.monthlyWiseSlaryIndex-1,
        })
      }

      setAnimationDirection({
        departmentWiseCountAnimation: "",
        departmentWiseEarnedGrossAnimation: "",
        departmentWiseNetGrossAnimation: "",
        departmentWiseOverTimeHoursAnimation: "",
        monthlySalarAnimation:" ",
      });
      setAnimating(false);
    }, 500);
  };
  const handleNext = (type) => {
    if (animating) return;
    if (type === "1") {
      setAnimationDirection({
        ...animationDirection,
        departmentWiseCountAnimation: "slide-left",
      });
    } else if (type === "2") {
      setAnimationDirection({
        ...animationDirection,
        departmentWiseEarnedGrossAnimation: "slide-left",
      });
    } else if (type === "3") {
      setAnimationDirection({
        ...animationDirection,
        departmentWiseNetGrossAnimation: "slide-left",
      });
    } else if (type === "4") {
      setAnimationDirection({
        ...animationDirection,
        departmentWiseOverTimeHoursAnimation: "slide-left",
      });
    }
    else if(type ==="5"){
      setAnimationDirection({
      ...animationDirection,
      monthlySalarAnimation: "slide-left",  
      })
    }
    setAnimating(true);
    setTimeout(() => {
      if (type === "1") {
        setCurrentIndex({
          ...currentIndex,
          departmentWiseCountIndex:
            currentIndex?.departmentWiseCountIndex ===
            chartOptions.series.length - 1
              ? 0
              : currentIndex?.departmentWiseCountIndex + 1,
        });
      } else if (type === "2") {
        setCurrentIndex({
          ...currentIndex,
          departmentWiseEarnedGrossIndex:
            currentIndex?.departmentWiseEarnedGrossIndex ===
            chartEarnedOptions.series.length - 1
              ? 0
              : currentIndex?.departmentWiseEarnedGrossIndex + 1,
        });
      } else if (type === "3") {
        setCurrentIndex({
          ...currentIndex,
          departmentWiseNetGrossIndex:
            currentIndex?.departmentWiseNetGrossIndex ===
            chartNetOptions.series.length - 1
              ? 0
              : currentIndex?.departmentWiseNetGrossIndex + 1,
        });
      } else if (type === "4") {
        setCurrentIndex({
          ...currentIndex,
          departmentWiseOverTimeHoursIndex:
            currentIndex?.departmentWiseOverTimeHoursIndex ===
            chartNetOptions.series.length - 1
              ? 0
              : currentIndex?.departmentWiseOverTimeHoursIndex + 1,
        });
        
        setCurrentIndex1((prev) =>
          prev === chartOverTimeOptions.series.length - 1 ? 0 : prev + 1
        );
      
      } else if(type === "5"){
        setCurrentIndex({
          ...currentIndex,
          monthlyWiseSlaryIndex:
          currentIndex?.monthlyWiseSlaryIndex === chartSalaryOptions.series.length - 1
          ? 0
          : currentIndex?.monthlyWiseSlaryIndex +1,
        })
      }
      setAnimationDirection({
        departmentWiseCountAnimation: "",
        departmentWiseEarnedGrossAnimation: "",
        departmentWiseNetGrossAnimation: "",
        departmentWiseOverTimeHoursAnimation: "",
        monthlySalarAnimation:" ",
      });
      setAnimating(false);
    }, 500);
  };
  return (
    <div className="card p-2">
      <div className="">
        <div className="row col-md-12 mb-3">
         
        <div className="row">
        <div className="col-md-3">
            <div className="card-body">
              <label htmlFor="from_month" className="form-label">
                From Month Year:
              </label>
              <Select
                id="from_month"
                name="from_month"
                value={
                  selectedFromMonth
                    ? monthYearOptions.find(
                        (option) => option.value === selectedFromMonth
                      )
                    : null
                }
                onChange={(selectedOption) =>
                  handleSelectChange("from_month", selectedOption)
                }
                options={monthYearOptions}
                placeholder={"Select From Month-Year"}
              />
              {errors.from_month && (
                <p style={{ color: "red" }}>{errors.from_month}</p>
              )}
            </div>
        </div>

        <div className="col-md-3">
            <div className="card-body">
              <label htmlFor="to_month" className="form-label">
                To Month Year:
              </label>
              <Select
                id="to_month"
                name="to_month"
                value={
                  selectedToMonth
                    ? monthYearOptions.find(
                        (option) => option.value === selectedToMonth
                      )
                    : null
                }
                options={toMonthOptions}
                onChange={(selectedOption) =>
                  handleSelectChange("to_month", selectedOption)
                }
                placeholder={"Select To Month-Year"}
              />
              {errors.to_month && (
                <p style={{ color: "red" }}>{errors.to_month}</p>
              )}
           
            </div>
        </div>
        <div className="col-md-3 mt-3">
          <div className="row">
            <div className="col-md-6">
            <div>
              <label>Apply Filter</label>
            </div>
            <SubmitButton disabled={loadingFilter || isFilterDisabled} loading={loadingFilter} buttonName='Filter' loadingMessage='Loading' onClick={handleApplyFilter} 
            icon={"ri-filter-3-fill"} type='info' />
            </div>

            <div className="col-md-6">
            <div>
              <label>Clear Filter</label>
            </div>
            <button
              type="button"
              onClick={handleClearFilter}
              disabled={loadingFilter2 || isFilterDisabled}
              className="btn btn-secondary w-100"
            >
              {loadingFilter2 ? (
                <span className="spinner-border spinner-border-sm"></span>
              ) : (
                <>
                  <i className="ri-database-2-line label-icon align-middle fs-16 me-2" />
                clear
                </>
              )}
            </button>
            </div>        
          </div>
        </div>
        </div>

         
          
          </div>
      </div>
      
    
      <div className="row">

        

        <div className="col-xl-6">
          <div ref={sourceDivRef} className="card p-2">
            <div>
              <div className="text-center mt-3">
                <h5>Department Wise Earned Gross Salary and Deductions</h5>
              </div>
            </div>
            <div className="overflow-hidden">
              {loading ? (
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ height: "65vh" }}
                >
                  <div className="text-center">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                </div>
              ) : (
                <>
                  {departmentGrossAndDeductionData > 5 && (
                    <button
                      onClick={() => handlePrev("2")}
                      className="nav-btn prev-btn"
                    >
                      Prev
                    </button>
                  )}
                  <div
                    className={`chart-wrapper ${animationDirection?.departmentWiseEarnedGrossAnimation}`}
                  >
                    <ApexCharts
                      options={{
                        chart: {
                          type: "bar",
                          height: "50vh",
                          toolbar: { show: true },
                        },
                        plotOptions: {
                          bar: {
                            horizontal: true,
                            columnWidth: "70%",
                            endingShape: "rounded",
                          },
                        },
                        colors: ["#69ea87", "#ed6464"],
                        dataLabels: {
                          enabled: true,
                          style: {
                            fontSize: "12px",
                            colors: ["#086208", "#700808"],
                          },
                          offsetX: 10,
                          formatter: function (val) {
                            return `₹ ${val}`;
                          },
                        },
                        stroke: {
                          show: true,
                          width: 2,
                          colors: ["transparent"],
                        },
                        xaxis: {
                          categories:
                            Array.isArray(chartEarnedOptions?.labels) &&
                            chartEarnedOptions?.labels.length > 0
                              ? chartEarnedOptions.labels[
                                  currentIndex?.departmentWiseEarnedGrossIndex ||
                                    0
                                ]
                              : ["No Data"],
                          title: {
                            text: `Amount (INR) ${
                              departmentGrossAndDeductionData > 5
                                ? `(${
                                    currentIndex?.departmentWiseEarnedGrossIndex +
                                    1
                                  }-${chartEarnedOptions?.labels.length})`
                                : ""
                            }`,
                            style: { fontSize: "12px", fontWeight: "bold" },
                          },
                        },
                        yaxis: {
                          title: {
                            text: `Departments`,
                            style: { fontSize: "12px", fontWeight: "bold" },
                          },
                        },
                        fill: { opacity: 1 },
                        legend: {
                          position: "top",
                          horizontalAlign: "center",
                        },
                        tooltip: {
                          y: {
                            formatter: (value) => `₹${value}`,
                          },
                        },
                      }}
                      series={[
                        {
                          name: "Earned Gross",
                          data:
                            Array.isArray(chartEarnedOptions?.series) &&
                            chartEarnedOptions?.series.length > 0 &&
                            chartEarnedOptions?.series[
                              currentIndex?.departmentWiseEarnedGrossIndex
                            ].length > 0
                              ? chartEarnedOptions.series[
                                  currentIndex?.departmentWiseEarnedGrossIndex
                                ][0]?.data 
                              : [0],
                        },
                        {
                          name: "Deductions",
                          data:
                            Array.isArray(chartEarnedOptions?.series) &&
                            chartEarnedOptions?.series.length > 0 &&
                            chartEarnedOptions?.series[
                              currentIndex?.departmentWiseEarnedGrossIndex
                            ].length > 1
                              ? chartEarnedOptions.series[
                                  currentIndex?.departmentWiseEarnedGrossIndex
                                ][1]?.data 
                              : [0],
                        },
                      ]}
                      type="bar"
                    />
                  </div>
                  {departmentGrossAndDeductionData > 5 && (
                    <button
                      onClick={() => handleNext("2")}
                      className="nav-btn next-btn"
                    >
                      Next
                    </button>
                  )}
                </>
              )}
            </div>
          </div>
        </div>

        <div className="col-xl-6">
          <div ref={sourceDivRef} className="card p-2">
            <div>
              <div className="text-center mt-3">
                <h5>Department Wise Net Salary</h5>
              </div>
            </div>
            <div className="overflow-hidden">
              {loading1 ? (
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ height: "65vh" }}
                >
                  <div className="text-center">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                </div>
              ) : (
                <>
                  {departmentNetSalaryData > 5 && (
                    <button
                      onClick={() => {
                        handlePrev("3");
                      }}
                      className="nav-btn prev-btn"
                    >
                      Prev
                    </button>
                  )}

                  <div
                    className={`chart-wrapper ${animationDirection?.departmentWiseNetGrossAnimation}`}
                  >
                    <ApexCharts
                      options={{
                        chart: {
                          type: "bar",
                          height: "50vh",
                          toolbar: { show: true },
                        },
                        plotOptions: {
                          bar: {
                            horizontal: true,
                            columnWidth: "55%",
                            endingShape: "rounded",
                          },
                        },
                        colors: ["#FF69B4"],
                        dataLabels: {
                          enabled: true,
                          style: {
                            fontSize: "12px",
                            colors: ["#630455"],
                          },
                          offsetX: 10,
                          formatter: function (val) {
                            return `₹ ${val}`;
                          },
                        },
                        stroke: {
                          show: true,
                          width: 2,
                          colors: ["transparent"],
                        },
                        xaxis: {
                          categories:
                            Array.isArray(chartNetOptions?.labels) &&
                            chartNetOptions?.labels.length > 0
                              ? chartNetOptions.labels[
                                  currentIndex?.departmentWiseNetGrossIndex
                                ]
                              : ["No Data"],

                          title: {
                            text: `Net Salary INR ${
                              departmentNetSalaryData > 5
                                ? `(${
                                    currentIndex?.departmentWiseNetGrossIndex +
                                    1
                                  }-${chartNetOptions?.labels.length})`
                                : ""
                            }`,
                            style: { fontSize: "12px", fontWeight: "bold" },
                          },
                        },
                        yaxis: {
                          title: {
                            text: `Departments`,
                            style: { fontSize: "12px", fontWeight: "bold" },
                          },
                        },
                        fill: { opacity: 1 },
                        legend: {
                          position: "top",
                          horizontalAlign: "center",
                        },
                        tooltip: {
                          y: {
                            formatter: function (value) {
                              return `${value}`;
                            },
                          },
                          // x: {
                          //   formatter: function (value) {
                          //     return `₹ ${value}`;
                          //   },
                          // },
                        },
                      }}
                      series={[
                        Array.isArray(chartNetOptions?.series) &&
                        chartNetOptions.series.length > 0
                          ? chartNetOptions.series[
                              currentIndex?.departmentWiseNetGrossIndex
                            ]
                          : { name: "No Data", data: [0] },
                      ]}
                      type="bar"
                    />
                  </div>

                  {departmentNetSalaryData > 5 && (
                    <button
                      onClick={() => {
                        handleNext("3");
                      }}
                      className="nav-btn next-btn"
                    >
                      Next
                    </button>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
        <div className="col-xl-6">
          <div className="card p-2">
            <div>
              <div className="text-center mt-3">
                <h5>Location Wise Net Salary</h5>
              </div>
            </div>

            <ApexCharts
              options={{
                chart: {
                  type: "donut",
                  height: "30vh",
                },
                labels: renderLabels(
                  chartNetLocOptions?.labels || ["No Data Available"]
                ),
                legend: {
                  position: "bottom",
                },
                plotOptions: {
                  pie: {
                    donut: {
                      size:
                        chartNetLocOptions?.labels?.length > 10 ? "70%" : "65%",
                      labels: {
                        show: false,
                        name: {
                          show: false,
                        },
                        value: {
                          show: true,
                          formatter: function (val, opts) {
                            const value =
                              opts?.w?.config?.series?.[opts.seriesIndex] ??
                              val;
                            return `₹ ${value}`;
                          },
                        },
                      },
                    },
                  },
                },
                dataLabels: {
                  enabled: false,
                  formatter: function (val, opts) {
                    // Add ₹ symbol before the value
                    const value =
                      opts?.w?.config?.series?.[opts.seriesIndex] ?? val;
                    return `₹ ${value}`;
                  },
                },
              }}
              series={renderSeries(chartNetLocOptions?.series || [0])}
              type="donut"
            />
          </div>
        </div>
        <div className="col-xl-6">
          <div ref={sourceDivRef} className="card p-2">
            <div>
              <div className="text-center mt-3">
                <h5>Location Wise Earned Gross Salary</h5>
              </div>
            </div>

            {/* <ApexCharts
            options={{
              chart: {
                type: "donut",
                height: "30vh",
              },
              labels:
                Array.isArray(chartEarnedLocOptions?.labels) && chartEarnedLocOptions?.labels.length > 0
                  ? chartEarnedLocOptions.labels
                  : ["No Data"],
              legend: {
                position: "bottom",
              },
              plotOptions: {
                pie: {
                  donut: {
                    size: chartEarnedLocOptions?.labels?.length > 10 ? "70%" : "65%",
                    labels: {
                      show: false,
                      name: {
                        show: Array.isArray(chartEarnedLocOptions?.labels) && chartEarnedLocOptions?.labels.length > 0,
                      },
                      value: {
                        show: true,
                      },
                    },
                  },
                },
              },
            }}
            series={
              Array.isArray(chartEarnedLocOptions?.series) && chartEarnedLocOptions?.series.length > 0
                ? chartEarnedLocOptions.series
                : [0]
            }
            type="donut"
          /> */}
            <ApexCharts
              options={{
                chart: {
                  type: "donut",
                  height: "30vh",
                },
                labels:
                  Array.isArray(chartEarnedLocOptions?.labels) &&
                  chartEarnedLocOptions?.labels.length > 0
                    ? chartEarnedLocOptions.labels
                    : ["No Data"],
                legend: {
                  position: "bottom",
                },
                plotOptions: {
                  pie: {
                    donut: {
                      size:
                        chartEarnedLocOptions?.labels?.length > 10
                          ? "70%"
                          : "65%",
                      labels: {
                        show: false,
                        name: {
                          show:
                            Array.isArray(chartEarnedLocOptions?.labels) &&
                            chartEarnedLocOptions?.labels.length > 0,
                        },
                        value: {
                          show: true,
                          formatter: function (val, opts) {
                            // Add ₹ symbol before the value
                            const value =
                              opts?.w?.config?.series?.[opts.seriesIndex] ??
                              val;
                            return `₹ ${value}`;
                          },
                        },
                      },
                    },
                  },
                },
                dataLabels: {
                  enabled: false,
                  formatter: function (val, opts) {
                    // Add ₹ symbol before the value
                    const value =
                      opts?.w?.config?.series?.[opts.seriesIndex] ?? val;
                    return `₹ ${value}`;
                  },
                },
              }}
              series={
                Array.isArray(chartEarnedLocOptions?.series) &&
                chartEarnedLocOptions?.series.length > 0
                  ? chartEarnedLocOptions.series
                  : [0]
              }
              type="donut"
            />
          </div>
        </div>
        <div className="container"></div>
        {/* <div className="text-center mt-3">
          <h5>Designation Wise Employee Salary Projection</h5>
        </div>
        <div className="card-header">
          <div className=" row">
            <div className="col-md-3 position-relative me-2">
              <label htmlFor="selected_Month" className="form-label">
                Selected Month Year:
              </label>
              <div className="position-absolute z-2 w-100">
                <Select
                  id="selected_Month"
                  name="selected_Month"
                  value={
                    selectedMonthYear
                      ? monthYearOptions.find(
                          (option) => option.value === selectedMonthYear
                        )
                      : null
                  }
                  onChange={(selectedOption) =>
                    handleSelectedMonthChange(selectedOption)
                  }
                  options={monthYearOptions}
                  placeholder={"Select Month-Year"}
                />
              </div>
              {errors.selected_Month && (
                <p style={{ color: "red" }}>{errors.selected_Month}</p>
              )}
            </div>
            <div className="col-md-3">
              <div className="">
                <label htmlFor="to_month" className="form-label">
                  Next Month Year:
                </label>
                <Select
                  id="to_month"
                  name="to_month"
                  value={
                    selectedNextMonth
                      ? monthYearOptions.find(
                          (option) => option.value === selectedNextMonth
                        )
                      : null
                  }
                  options={monthYearOptions}
                  onChange={(selectedOption) =>
                    handleToMonthChange(selectedOption)
                  }
                  placeholder={"Next Month-Year"}
                  isDisabled={true} // Disabled to prevent manual selection
                />
                {errors.to_month && (
                  <p style={{ color: "red" }}>{errors.to_month}</p>
                )}
              </div>
            </div>
          </div>
        </div> */}

        {/* <div
          style={{ maxHeight: "75vh", overflowY: "auto", overflowX: "auto" }}
        >
          <table
            style={{ minWidth: "100%" }}
            className="table table-borderless table-hover align-middle mb-0 table-bordered table-stripped"
          >
            <thead className="bg-primary text-light bg-gradient sticky-top z-1 ">
              <tr>
                <th>Sr No.</th>
                <th>Designation</th>
                <th>Employees count Of Selected Month</th>
                <th>Employees count Of Next Month</th>
                <th>Selected Month Salary (CTC)</th>
                <th>Next Month Salary (CTC)</th>
                <th>Percentage Rate</th>
              </tr>
            </thead>
            {rows.length === 0 ? (
              <tbody>
                <tr>
                  <td colSpan={7}>
                    <NoRecords />
                  </td>
                </tr>
              </tbody>
            ) : (
              <tbody>
                {rows.map((row, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td> 
                    <td>{row.designation_name}</td>
                    <td>{row.selectedmonth_total_employees}</td>{" "}
                   
                    <td>{row.nextmonth_total_employees}</td>{" "}
                   
                    <td>{row.previous_avg_salary}</td>{" "}
                    
                    <td>{row.current_avg_salary}</td> 
                    <td className={`text-${row.percentage_status}`}>
                      {row.percentage_change}
                    </td>{" "}
                   
                  </tr>
                ))}
              </tbody>
            )}
          </table>
        </div> */}

<div className="col-xl-6">
  <div ref={sourceDivRef} className="card p-2">
    <div>
      <div className="text-center mt-3">
        <h5>Monthly Earned Gross , Deductions And Net Salary</h5>
      </div>
    </div>
    <div className="overflow-hidden">
      {loading ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "65vh" }}
        >
          <div className="text-center">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      ) : (
        <>
          {monthlySalary > 5 && (
            <button
              onClick={() => handlePrev("2")}
              className="nav-btn prev-btn"
            >
              Prev
            </button>
          )}
          <div
            className={`chart-wrapper ${animationDirection?.monthlySalarAnimation}`}
          >
            <ApexCharts
              options={{
                chart: {
                  type: "bar",
                  height: "50vh",
                  toolbar: { show: true },
                },
                plotOptions: {
                  bar: {
                    horizontal: false, 
                    columnWidth: "70%",
                    endingShape: "rounded",
                  },
                },
                colors: ["#69ea87", "#ed6464" ,"#007bff"],
                dataLabels: {
                  enabled: false,
                  style: {
                    fontSize: "12px",
                    colors: ["#086208", "#700808"],
                  },
                  offsetX: 10,
                  formatter: function (val) {
                    return `₹ ${val}`;
                  },
                },
                stroke: {
                  show: true,
                  width: 2,
                  colors: ["transparent"],
                },
                xaxis: {
                  categories:
                    Array.isArray(chartSalaryOptions?.labels) &&
                    chartSalaryOptions?.labels.length > 0
                      ? chartSalaryOptions.labels[
                          currentIndex?.monthlyWiseSlaryIndex || 0
                        ]
                      : ["No Data"],
                  title: {
                    
                      text: `Month Year`,
                      style: { fontSize: "12px", fontWeight: "bold" },
                    
                },

                },
                yaxis: {
                  title: {
                      text: `Amount ${monthlySalary > 5 ? `(${
                        currentIndex?.monthlyWiseSlaryIndex + 1
                      }-${chartSalaryOptions?.labels.length})` : ""}`,
                      style: { fontSize: "12px", fontWeight: "bold" },
                  },
                },
                // yaxis: {
                //   title: {
                //     text: `Amount (INR)`,
                //     style: { fontSize: "12px", fontWeight: "bold" },
                //   },
                // },
                fill: { opacity: 1 },
                legend: {
                  position: "top",
                  horizontalAlign: "center",
                },
                tooltip: {
                  y: {
                    formatter: (value) => `₹${value}`,
                  },
                },
              }}
              series={[
                {
                  name: "Earned Gross",
                  data:
                    Array.isArray(chartSalaryOptions?.series) &&
                    chartSalaryOptions?.series.length > 0 &&
                    chartSalaryOptions?.series[
                      currentIndex?.monthlyWiseSlaryIndex
                    ]?.length > 0
                      ? chartSalaryOptions.series[
                          currentIndex?.monthlyWiseSlaryIndex
                        ][0]?.data
                      : [0],
                },
                {
                  name: "Deductions",
                  data:
                    Array.isArray(chartSalaryOptions?.series) &&
                    chartSalaryOptions?.series.length > 0 &&
                    chartSalaryOptions?.series[
                      currentIndex?.monthlyWiseSlaryIndex
                    ]?.length > 1
                      ? chartSalaryOptions.series[
                          currentIndex?.monthlyWiseSlaryIndex
                        ][1]?.data
                      : [0],
                },
                {
                  name: "Net",
                  data:
                    Array.isArray(chartSalaryOptions?.series) &&
                    chartSalaryOptions?.series.length > 0 &&
                    chartSalaryOptions?.series[
                      currentIndex?.monthlyWiseSlaryIndex
                    ]?.length > 1
                      ? chartSalaryOptions.series[
                          currentIndex?.monthlyWiseSlaryIndex
                        ][1]?.data
                      : [0],
                },
              ]}
              type="bar"
            />
          </div>
          {monthlySalary > 5 && (
            <button
              onClick={() => handleNext("2")}
              className="nav-btn next-btn"
            >
              Next
            </button>
          )}
        </>
      )}
    </div>
  </div>
</div>


      </div>
    </div>
  );
};
export default SalaryDashboard;
